import { useEffect } from "react";
import FocusLock from "react-focus-lock";
import AuthMpProvider from "@/core/data-provider/data-mp/auth/auth-mp-provider";
import { Button } from "@/shared/ui";
import { PIN_LENGTH } from "@/domains/auth/constants/other.ts";
import AuthPin from "@/domains/auth/components/AuthPin.tsx";

type Props = {
  pin: string;
  onPinChange: (value: string) => void;
  onSubmit: () => void;
  error?: string;
  pending: boolean;
};

export default function AuthSignInPin({ pin, onPinChange, onSubmit, error = "", pending }: Props) {
  useEffect(() => {
    if (pin.length === PIN_LENGTH && !pending) {
      onSubmit();
    }
  }, [pin, pending, onSubmit]);

  return (
    <FocusLock className="contents">
      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          if (!pin) return;
          onSubmit();
        }}
        className="gap-3 grow flex flex-col"
      >
        <AuthPin code={pin} onCodeChange={onPinChange} title="Введите пин-код:" />
        <button
          type="button"
          className="underline decoration-1 underline-offset-2 hover:text-white/75 transition mx-auto mt-1"
          onClick={AuthMpProvider.goToSignIn}
        >
          Забыли пин-код?
        </button>
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button className="btn--md w-full" submit loading={pending}>
            Войти в игру
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
